import React from "react";
import styles from "./SimulationDetail.module.sass";

import {simulationType} from "../../containers/Products/Products";
import Button from "../ui/Button/Button";
import Input from "../ui/Input/Input";
import Title from "../../components/Title/Title";
import gaTags from "../../utils/ga-tags"

import Tooltip from "../ui/Tooltip/Tooltip";

class SimulationDetail extends React.Component {
  targetDiv = React.createRef();

  scrollToDiv = () => {
    this.targetDiv.scrollIntoView({behavior: "smooth", block: "start"});
  };

  render() {
    const typeString =
      this.props.type === simulationType.PARCELA ? "da parcela" : "do crédito";

    const product = parseInt(this.props.selectedProduct.id) === 1 ? 'Imóvel' : 'Veículo';
    const gaTypeName = `${gaTags.type}&${product}&-&${this.props.type}&-&${this.props.value}&-Simulação`

    return (
      <div
        ref={el => {
          this.targetDiv = el;
        }}
        className={styles.SimulationDetail}
      >
        <Title title={`Valor ${typeString}`}
               tooltip={
                 <Tooltip>
                   <p><b>Temos algo importante para te lembrar:</b></p>
                   <p>Para começar um consórcio, é ideal ter uma <b>renda mensal ou faturamento anual comprovados</b> 3x
                     maior que a parcela escolhida.</p>
                 </Tooltip>
               }
        />

        <p
          className={styles.LimitsLabel}
        >{`Para fazer a simulação o valor mínimo ${typeString} deve ser R$ ${
          this.props.limits.minVal
          } e máximo de R$ ${this.props.limits.maxVal}`}</p>

        <Input
          type="currency"
          valid={this.props.isValid}
          error={"Ops! Valor da parcela ou total do crédito inválido."}
          value={this.props.value}
          onChange={this.props.valueChanged}
          onKeyPress={(event) => {
            return event.key === 'Enter' && this.props.isValid ? this.props.simulate() : null
          }}
        />
        <div className={styles.divider}/>
        <Button
          selected
          disabled={!this.props.isValid}
          onClick={this.props.simulate}
          data-gacategory={gaTags.categoryDefault}
          data-gatype={gaTypeName}
          data-gafunc={`${gaTypeName}-VerOferta`}
        >
          Ver oferta
        </Button>
      </div>
    );
  }
}

export default SimulationDetail;
